module.exports = __webpack_public_path__ + "img/cooker-dome-casing_140x116.806e3a1c.png";